import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}categories`;

export const getCategoriess = () => {
    const token = localStorage.getItem('token');

    return axios.get(API_URL + '/active', {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    })
}

export const getCategoriesById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}